import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadMoreList, serverChanner, gmToolNewPage } from "@/mixins/index";
import { gameAnnounceData, gameAnnounceDel, gameByPkg } from "@/api/gmToolNew/gmToolNew";
import addInGame from "./components/addInGame";
export default {
  name: "InGame",
  mixins: [loadMoreList, serverChanner, gmToolNewPage],
  components: {
    addInGame: addInGame
  },
  data: function data() {
    return {
      pagingReqFn: gameAnnounceData,
      pagingReqValue: "data",
      paramsData: {
        announce_type: '',
        language: '',
        state: '0',
        pkgs: []
      },
      drawer: false,
      content: '',
      delIds: [],
      pkgList: [],
      state: [{
        label: this.$t('all'),
        value: '0'
      }, {
        label: this.$t('enabled'),
        value: 1
      }, {
        label: this.$t('disabled'),
        value: 2
      }],
      top: [{
        label: this.$t('all'),
        value: ''
      }, {
        label: this.$t('top'),
        value: 1
      }, {
        label: this.$t('notTop'),
        value: 0
      }]
    };
  },
  activated: function activated() {
    this.getList();
    this.getPkgList();
  },
  methods: {
    getPkgList: function getPkgList() {
      var _this = this;

      gameByPkg({
        game_id: this.rawData.game_id
      }).then(function (res) {
        if (res.status == 200) {
          _this.pkgList = res.data;
        }
      });
    },
    handleSelectionChange: function handleSelectionChange(e) {
      this.delIds = e;
    },
    viewOpen: function viewOpen(content) {
      this.content = this.$utils.textRepl(content);
      this.drawer = true;
    },
    del: function del(dateList) {
      var _this2 = this;

      var ids = dateList.map(function (item) {
        return item.id;
      });
      this.$store.dispatch('d2admin/method/deleteList', {
        req: gameAnnounceDel,
        data: {
          id: ids.toString(),
          env_id: this.paramsData.env_id
        }
      }).then(function () {
        _this2.getList();
      });
    }
  }
};